import { MenuItem } from "@mui/material"

import { HoverActionMenu } from "../../../../../shared/components/table/HoverActionMenu"
import { SurveyQuestion } from "../merchantSurveyTypes"

// TODO: need to change any
interface ActionMenuItem {
    text: string
    onClick: (item: any) => void
}

interface ActionMenuProps {
    item: SurveyQuestion
    menuItems: ActionMenuItem[]
}

export const ActionMenu = ({ item, menuItems }: ActionMenuProps) => {
    return (
        <HoverActionMenu>
            {(closeMenu) =>
                menuItems.map((menuItem, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            menuItem.onClick(item)
                            closeMenu()
                        }}
                    >
                        {menuItem.text}
                    </MenuItem>
                ))
            }
        </HoverActionMenu>
    )
}
